import { OS_INDEX_ALIAS } from "@app/util/constant";
import { sortByStickyAndRecentDate } from "@caas/queries/constant";
import { CaasQuery, GenQueryProps } from "@caas/types";

export const queryByKeywords = ({
  queryTerms,
  size,
  page,
  source,
  sort,
  offset,
}: GenQueryProps): CaasQuery => {
  const from = size * (page - 1) + (offset || 0);

  const keywordsQuery = [
    {
      nested: {
        path: "data.context.tags",
        query: [{ terms: { "data.context.tags.urlPath.keyword": queryTerms } }],
      },
    },
    {
      nested: {
        path: "data.context.tags",
        query: [
          { terms: { "data.context.tags.urlPathHistory.keyword": queryTerms } },
        ],
      },
    },
  ];

  return {
    index: OS_INDEX_ALIAS,
    search: {
      query: {
        bool: {
          should: keywordsQuery,
          minimum_should_match: 1,
          must: [
            {
              term: {
                "data.context.displaySetting.hideFromSectionListing": false,
              },
            },
          ],
        },
      },
      size: size,
      from: from > 0 ? from : 0,
      sort: sort || sortByStickyAndRecentDate,
      ...(source ? { _source: source } : undefined),
    },
  };
};
